import React, { Component } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import Room from './components/Room';
import './style.scss';
import {cloneDeep, findIndex, orderBy} from 'lodash';
import { getRooms, getQuizs, updateQuiz, updateRoom, deleteQuiz, updateQuizOrder, updateRoomsOrder } from './actions';
import PropTypes from 'prop-types'
import Spiner from '../helpers/Spiner/Spiner';
import { connect } from 'react-redux'
import { setLoadCursore } from '../../redux/actions';


class Quizs extends Component {
  static contextTypes = {formatMessage: PropTypes.any};

	constructor(props) {
			super(props)
			this.state = {
					rooms: [],
					loaded: false,
			}
	}

	getData = async () => {
		try {
			const {formatMessage} = this.context
			this.setState({loaded: false});
			let rooms = await getRooms();
			let quizs = await getQuizs();


			let tmp_room = {id: -1, title: formatMessage('txtMessageUnassignedQuizzes'), quizs: []};

			rooms = orderBy(rooms, ['x_order', 'id'], ['asc', 'asc']).map(room => ({...room, quizs: []}));


			quizs = quizs.map(i => {
				if(i.x_order){
					i.x_order = parseInt(i.x_order);
				}
				i.id = parseInt(i.id);
				return i;
			})

			orderBy(quizs, ['x_order', 'id'], ['asc', 'asc']).forEach(quiz => {
				if(!quiz.room){
					tmp_room.quizs.push(quiz);
				} else {
					const index = findIndex(rooms, ['id', quiz.room]);
					if(~index){
						rooms[index].quizs.push(quiz);
					}
				}
			});

			this.setState({rooms: [...rooms, tmp_room], loaded: true});

		} catch (error) {
			
		}
	}

	async componentDidMount(){
		this.getData();
	}
    


	onDragEnd = async (result) => {
		const { destination, source, type } = result;

		if(!destination){
			return;
		}

		if(destination.droppableId === source.droppableId && destination.index === source.index){
			return;
		}

		try {
			if(type == 'quiz'){
				const source_room = this.state.rooms.find(item => item.id == source.droppableId.replace('room-', ''));
				const destination_room = this.state.rooms.find(item => item.id == destination.droppableId.replace('room-', ''));
	
				const source_room_quiz = {...source_room.quizs[source.index]};
	
				if(source_room.id != destination_room.id){
					source_room_quiz.room = destination_room.id == -1 ? null : destination_room.id;
					this.props.setLoadCursore(true);
					await updateQuiz({...source_room_quiz});
					this.props.setLoadCursore(true);
				}
	
				source_room.quizs.splice( source.index, 1);
				destination_room.quizs.splice( destination.index, 0, source_room_quiz);
	
				const newRooms = cloneDeep(this.state.rooms.map(item => {
					if(item.id == source_room.id) {
						return {...source_room}
					}
					if(item.id == destination_room.id) {
						return {...destination_room}
					}
					return {...item}
				}))
				this.props.setLoadCursore(true);
				this.setState({
					rooms: newRooms
				});

				await updateQuizOrder({quiz: JSON.stringify(destination_room.quizs.map((quiz, index) => ({x_order: index, id: quiz.id})))});

				// await Promise.all(destination_room.quizs.map((quiz, index) => updateQuiz({...quiz, x_order: index})));
				this.props.setLoadCursore(false);
				
			} else if (type == 'room') {
				const rooms = cloneDeep(this.state.rooms); 
	
				const room = rooms[source.index];
	
				rooms.splice( source.index, 1);
				rooms.splice( destination.index, 0, room);
				this.props.setLoadCursore(true);
				this.setState({rooms});

				await updateRoomsOrder({rooms: JSON.stringify(rooms.filter(item => item.id > 0).map((room, index) => ({x_order: index, id: room.id})))});


				// await Promise.all(rooms.filter(item => item.id > 0).map((room, index) => updateRoom({...room, x_order: index})))
				this.props.setLoadCursore(false);
			}	
		} catch (error) {
			this.props.setLoadCursore(false);
		}
	}

	deleteQuiz = async (id) => {
		try {
			await deleteQuiz({id});

			const rooms = cloneDeep(this.state.rooms);
			
			rooms.forEach(room => {
				const index = findIndex(room.quizs, ['id', id]);
				if(~index){
					room.quizs.splice( index, 1);
				}
			})

			this.setState({ rooms });

			return true;
		} catch (error) {
			
		}
	}

  render() {
		const { loaded, rooms } = this.state;
		if(!loaded){
			return <Spiner/>
		}
    return (
			<div className="qbm-content Quizs">
				<div className="q-rooms ">
					<DragDropContext
						onDragEnd={this.onDragEnd}
					>
						<Droppable droppableId="all-rooms" direction="vertical" type="room">
							{(provided) => (<div
							 ref={provided.innerRef}
							 {...provided.droppableProps}
							>
								{rooms.map((room, index) => <Room getData={this.getData} key={room.id} index={index} room={room} rooms={rooms} deleteQuiz={this.deleteQuiz} />)}
								{provided.placeholder}
							</div>
							)}
						</Droppable>
					</DragDropContext>
				</div>
      </div>
    );
  }
}


const mapStateToProps = (state, ownProps) => ({
	
})

const mapDispatchToProps = {
	setLoadCursore
}

export default connect(mapStateToProps, mapDispatchToProps)(Quizs)




// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Quizs/index.jsx